webpackJsonp([0,2],{

/***/ "/356":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_rxjs_operators__ = __webpack_require__("F5VT");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatModule; });

// This allows us to load Angular components on legacy server-side pages.
var CompatModule = (function () {
    function CompatModule() {
    }
    return CompatModule;
}());

//# sourceMappingURL=compat.module.js.map

/***/ }),

/***/ "/fcW":
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "/fcW";


/***/ }),

/***/ "/wVU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__environments_environment__ = __webpack_require__("kZql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__("Qbdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gendir_compat_compat_module_ngfactory__ = __webpack_require__("Bq6/");




if (__WEBPACK_IMPORTED_MODULE_1__environments_environment__["a" /* environment */].production) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["a" /* enableProdMode */])();
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["a" /* platformBrowser */])().bootstrapModuleFactory(__WEBPACK_IMPORTED_MODULE_3__gendir_compat_compat_module_ngfactory__["a" /* CompatModuleNgFactory */]);
//# sourceMappingURL=main-compat.js.map

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("/wVU");


/***/ }),

/***/ "0D9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatNavigationComponent; });
var CompatNavigationComponent = (function () {
    function CompatNavigationComponent() {
    }
    CompatNavigationComponent.ctorParameters = function () { return []; };
    return CompatNavigationComponent;
}());

//# sourceMappingURL=compat-navigation.component.js.map

/***/ }),

/***/ "1LfM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component__ = __webpack_require__("wkYe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__ = __webpack_require__("sVtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__ = __webpack_require__("7eNd");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_NavigationPerformanceTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_NavigationPerformanceTrackingComponent_0;
/* unused harmony export NavigationPerformanceTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_NavigationPerformanceTrackingComponent = [];
var RenderType_NavigationPerformanceTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_11" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_NavigationPerformanceTrackingComponent,
    data: {}
});
function View_NavigationPerformanceTrackingComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [(l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_NavigationPerformanceTrackingComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'fl-navigation-performance-tracking', [], null, null, null, View_NavigationPerformanceTrackingComponent_0, RenderType_NavigationPerformanceTrackingComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component__["a" /* NavigationPerformanceTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__["a" /* Tracking */],
            __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]
        ], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var NavigationPerformanceTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* ɵccf */]('fl-navigation-performance-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component__["a" /* NavigationPerformanceTrackingComponent */], View_NavigationPerformanceTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9uYXZpZ2F0aW9uLXBlcmZvcm1hbmNlLXRyYWNraW5nLmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuTmF2aWdhdGlvblBlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuTmF2aWdhdGlvblBlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1uYXZpZ2F0aW9uLXBlcmZvcm1hbmNlLXRyYWNraW5nPjwvZmwtbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt5QkNBQTs7OztJQ0FBO2dCQUFBOzs7SUFBQTtLQUFBOzs7SUFBQTs7OyJ9
//# sourceMappingURL=navigation-performance-tracking.component.ngfactory.js.map

/***/ }),

/***/ "1Ui2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compat_compat_navigation_component__ = __webpack_require__("0D9j");
/* unused harmony export RenderType_CompatNavigationComponent */
/* unused harmony export View_CompatNavigationComponent_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatNavigationComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_CompatNavigationComponent = [];
var RenderType_CompatNavigationComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_11" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_CompatNavigationComponent,
    data: {}
});
function View_CompatNavigationComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [], null, null);
}
function View_CompatNavigationComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'app-compat-navigation', [], null, null, null, View_CompatNavigationComponent_0, RenderType_CompatNavigationComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](49152, null, 0, __WEBPACK_IMPORTED_MODULE_1__compat_compat_navigation_component__["a" /* CompatNavigationComponent */], [], null, null)
    ], null, null);
}
var CompatNavigationComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* ɵccf */]('app-compat-navigation', __WEBPACK_IMPORTED_MODULE_1__compat_compat_navigation_component__["a" /* CompatNavigationComponent */], View_CompatNavigationComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC1uYXZpZ2F0aW9uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQtbmF2aWdhdGlvbi5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQtbmF2aWdhdGlvbi5jb21wb25lbnQudHMuQ29tcGF0TmF2aWdhdGlvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxhcHAtY29tcGF0LW5hdmlnYXRpb24+PC9hcHAtY29tcGF0LW5hdmlnYXRpb24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO2dCQUFBOzs7OyJ9
//# sourceMappingURL=compat-navigation.component.ngfactory.js.map

/***/ }),

/***/ "5/rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_config__ = __webpack_require__("Tz6n");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__auth_config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_interface__ = __webpack_require__("LV28");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__auth_interface__);
/* unused harmony reexport AuthConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_module__ = __webpack_require__("OTuB");
/* unused harmony reexport AuthModule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_service__ = __webpack_require__("TZHD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__auth_service__["a"]; });
/* unused harmony reexport AuthState */




//# sourceMappingURL=index.js.map

/***/ }),

/***/ "5AIu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component_ngfactory__ = __webpack_require__("1LfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_navigation_performance_tracking_component__ = __webpack_require__("wkYe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_service__ = __webpack_require__("sVtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_tracking_tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_tracking_user_timing_tracking_component_ngfactory__ = __webpack_require__("jT3v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_user_timing_tracking_component__ = __webpack_require__("EVHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_shared_tracking_memory_leak_tracking_component_ngfactory__ = __webpack_require__("xfqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_shared_tracking_memory_leak_tracking_component__ = __webpack_require__("cjBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_shared_tracking_error_tracking_service__ = __webpack_require__("maH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_shared_tracking_synthetic_performance_tracking_component_ngfactory__ = __webpack_require__("SPEl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_synthetic_performance_tracking_component__ = __webpack_require__("yUzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ngx_cookie_src_cookie_service__ = __webpack_require__("A+9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__compat_compat_tracking_component__ = __webpack_require__("ZrHe");
/* unused harmony export RenderType_CompatTrackingComponent */
/* unused harmony export View_CompatTrackingComponent_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatTrackingComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














var styles_CompatTrackingComponent = [];
var RenderType_CompatTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_11" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_CompatTrackingComponent,
    data: {}
});
function View_CompatTrackingComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_16" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'fl-navigation-performance-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component_ngfactory__["a" /* View_NavigationPerformanceTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component_ngfactory__["b" /* RenderType_NavigationPerformanceTrackingComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_navigation_performance_tracking_component__["a" /* NavigationPerformanceTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_service__["a" /* Tracking */],
            __WEBPACK_IMPORTED_MODULE_4__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]
        ], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_16" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'fl-user-timing-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_5__app_shared_tracking_user_timing_tracking_component_ngfactory__["a" /* View_UserTimingTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_5__app_shared_tracking_user_timing_tracking_component_ngfactory__["b" /* RenderType_UserTimingTrackingComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_user_timing_tracking_component__["a" /* UserTimingTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_service__["a" /* Tracking */]], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_16" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'fl-memory-leak-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_7__app_shared_tracking_memory_leak_tracking_component_ngfactory__["a" /* View_MemoryLeakTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_7__app_shared_tracking_memory_leak_tracking_component_ngfactory__["b" /* RenderType_MemoryLeakTrackingComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_8__app_shared_tracking_memory_leak_tracking_component__["a" /* MemoryLeakTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_9__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */],
            __WEBPACK_IMPORTED_MODULE_4__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]
        ], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_16" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'fl-synthetic-performance-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_10__app_shared_tracking_synthetic_performance_tracking_component_ngfactory__["a" /* View_SyntheticPerformanceTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_10__app_shared_tracking_synthetic_performance_tracking_component_ngfactory__["b" /* RenderType_SyntheticPerformanceTrackingComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_synthetic_performance_tracking_component__["a" /* SyntheticPerformanceTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_12_ngx_cookie_src_cookie_service__["a" /* CookieService */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["_17" /* Renderer2 */]
        ], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_16" /* ɵted */](null, ['\n  ']))
    ], function (ck, v) {
        ck(v, 2, 0);
        ck(v, 5, 0);
        ck(v, 8, 0);
        ck(v, 11, 0);
    }, null);
}
function View_CompatTrackingComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'app-compat-tracking', [], null, null, null, View_CompatTrackingComponent_0, RenderType_CompatTrackingComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](49152, null, 0, __WEBPACK_IMPORTED_MODULE_13__compat_compat_tracking_component__["a" /* CompatTrackingComponent */], [], null, null)
    ], null, null);
}
var CompatTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* ɵccf */]('app-compat-tracking', __WEBPACK_IMPORTED_MODULE_13__compat_compat_tracking_component__["a" /* CompatTrackingComponent */], View_CompatTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC10cmFja2luZy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0LXRyYWNraW5nLmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC10cmFja2luZy5jb21wb25lbnQudHMuQ29tcGF0VHJhY2tpbmdDb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC10cmFja2luZy5jb21wb25lbnQudHMuQ29tcGF0VHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZmwtbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZz48L2ZsLW5hdmlnYXRpb24tcGVyZm9ybWFuY2UtdHJhY2tpbmc+XG4gICAgPGZsLXVzZXItdGltaW5nLXRyYWNraW5nPjwvZmwtdXNlci10aW1pbmctdHJhY2tpbmc+XG4gICAgPGZsLW1lbW9yeS1sZWFrLXRyYWNraW5nPjwvZmwtbWVtb3J5LWxlYWstdHJhY2tpbmc+XG4gICAgPGZsLXN5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZz48L2ZsLXN5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZz5cbiAgIiwiPGFwcC1jb21wYXQtdHJhY2tpbmc+PC9hcHAtY29tcGF0LXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtJQUNJO2dCQUFBOzs7SUFBQTtLQUFBO0lBQXlFO0lBQ3pFO2dCQUFBO0lBQW1EO0lBQ25EO2dCQUFBOzs7SUFBQTtLQUFBO0lBQW1EO0lBQ25EO2dCQUFBOzs7SUFBQTtLQUFBO0lBQXVFOzs7SUFIdkU7SUFDQTtJQUNBO0lBQ0E7Ozs7O0lDSko7Z0JBQUE7Ozs7In0=
//# sourceMappingURL=compat-tracking.component.ngfactory.js.map

/***/ }),

/***/ "7eNd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_CONFIG; });

var TRACKING_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["_10" /* OpaqueToken */]('TrackingConfig');
//# sourceMappingURL=tracking.config.js.map

/***/ }),

/***/ "8mlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatContactListComponent; });
var CompatContactListComponent = (function () {
    function CompatContactListComponent() {
    }
    CompatContactListComponent.ctorParameters = function () { return []; };
    return CompatContactListComponent;
}());

//# sourceMappingURL=compat-contact-list.component.js.map

/***/ }),

/***/ "Bq6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__ = __webpack_require__("/356");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_src_cookie_options_provider__ = __webpack_require__("8xgx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_auth_auth_service__ = __webpack_require__("TZHD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_tracking_error_tracking_service__ = __webpack_require__("maH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_custom_error_handler_service__ = __webpack_require__("UbRn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__ = __webpack_require__("Qbdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ngx_cookie_index__ = __webpack_require__("9db2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_shared_auth_auth_module__ = __webpack_require__("OTuB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_tracking_module__ = __webpack_require__("k/7A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_shared_tracking_tracking_service__ = __webpack_require__("sVtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__compat_tracking_component_ngfactory__ = __webpack_require__("5AIu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__compat_navigation_component_ngfactory__ = __webpack_require__("1Ui2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__compat_contact_list_component_ngfactory__ = __webpack_require__("I5QD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__compat_chat_component_ngfactory__ = __webpack_require__("D/cT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ngx_cookie_src_cookie_factory__ = __webpack_require__("Ji/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__app_shared_auth_auth_config__ = __webpack_require__("Tz6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ngx_cookie_src_cookie_service__ = __webpack_require__("A+9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__app_shared_tracking_tracking_config__ = __webpack_require__("7eNd");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatModuleNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





















var CompatModuleInjector = (function (_super) {
    __extends(CompatModuleInjector, _super);
    function CompatModuleInjector(parent) {
        return _super.call(this, parent, [
            __WEBPACK_IMPORTED_MODULE_13__compat_tracking_component_ngfactory__["a" /* CompatTrackingComponentNgFactory */],
            __WEBPACK_IMPORTED_MODULE_14__compat_navigation_component_ngfactory__["a" /* CompatNavigationComponentNgFactory */],
            __WEBPACK_IMPORTED_MODULE_15__compat_contact_list_component_ngfactory__["a" /* CompatContactListComponentNgFactory */],
            __WEBPACK_IMPORTED_MODULE_16__compat_chat_component_ngfactory__["a" /* CompatChatComponentNgFactory */]
        ], [
            __WEBPACK_IMPORTED_MODULE_13__compat_tracking_component_ngfactory__["a" /* CompatTrackingComponentNgFactory */],
            __WEBPACK_IMPORTED_MODULE_14__compat_navigation_component_ngfactory__["a" /* CompatNavigationComponentNgFactory */],
            __WEBPACK_IMPORTED_MODULE_15__compat_contact_list_component_ngfactory__["a" /* CompatContactListComponentNgFactory */],
            __WEBPACK_IMPORTED_MODULE_16__compat_chat_component_ngfactory__["a" /* CompatChatComponentNgFactory */]
        ]) || this;
    }
    Object.defineProperty(CompatModuleInjector.prototype, "_LOCALE_ID_20", {
        get: function () {
            if ((this.__LOCALE_ID_20 == null)) {
                (this.__LOCALE_ID_20 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["b" /* ɵn */](this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["c" /* LOCALE_ID */], null)));
            }
            return this.__LOCALE_ID_20;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_NgLocalization_21", {
        get: function () {
            if ((this.__NgLocalization_21 == null)) {
                (this.__NgLocalization_21 = new __WEBPACK_IMPORTED_MODULE_2__angular_common__["a" /* NgLocaleLocalization */](this._LOCALE_ID_20));
            }
            return this.__NgLocalization_21;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Compiler_22", {
        get: function () {
            if ((this.__Compiler_22 == null)) {
                (this.__Compiler_22 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* Compiler */]());
            }
            return this.__Compiler_22;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_APP_ID_23", {
        get: function () {
            if ((this.__APP_ID_23 == null)) {
                (this.__APP_ID_23 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["e" /* ɵg */]());
            }
            return this.__APP_ID_23;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_IterableDiffers_24", {
        get: function () {
            if ((this.__IterableDiffers_24 == null)) {
                (this.__IterableDiffers_24 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["f" /* ɵl */]());
            }
            return this.__IterableDiffers_24;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_KeyValueDiffers_25", {
        get: function () {
            if ((this.__KeyValueDiffers_25 == null)) {
                (this.__KeyValueDiffers_25 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["g" /* ɵm */]());
            }
            return this.__KeyValueDiffers_25;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_DomSanitizer_26", {
        get: function () {
            if ((this.__DomSanitizer_26 == null)) {
                (this.__DomSanitizer_26 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["b" /* ɵe */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__DomSanitizer_26;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Sanitizer_27", {
        get: function () {
            if ((this.__Sanitizer_27 == null)) {
                (this.__Sanitizer_27 = this._DomSanitizer_26);
            }
            return this.__Sanitizer_27;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_HAMMER_GESTURE_CONFIG_28", {
        get: function () {
            if ((this.__HAMMER_GESTURE_CONFIG_28 == null)) {
                (this.__HAMMER_GESTURE_CONFIG_28 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["d" /* HammerGestureConfig */]());
            }
            return this.__HAMMER_GESTURE_CONFIG_28;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_EVENT_MANAGER_PLUGINS_29", {
        get: function () {
            if ((this.__EVENT_MANAGER_PLUGINS_29 == null)) {
                (this.__EVENT_MANAGER_PLUGINS_29 = [
                    new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["e" /* ɵDomEventsPlugin */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])),
                    new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["f" /* ɵKeyEventsPlugin */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])),
                    new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["g" /* ɵHammerGesturesPlugin */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */]), this._HAMMER_GESTURE_CONFIG_28)
                ]);
            }
            return this.__EVENT_MANAGER_PLUGINS_29;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_EventManager_30", {
        get: function () {
            if ((this.__EventManager_30 == null)) {
                (this.__EventManager_30 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["h" /* EventManager */](this._EVENT_MANAGER_PLUGINS_29, this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* NgZone */])));
            }
            return this.__EventManager_30;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_\u0275DomSharedStylesHost_31", {
        get: function () {
            if ((this.__ɵDomSharedStylesHost_31 == null)) {
                (this.__ɵDomSharedStylesHost_31 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["i" /* ɵDomSharedStylesHost */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__ɵDomSharedStylesHost_31;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_\u0275DomRendererFactory2_32", {
        get: function () {
            if ((this.__ɵDomRendererFactory2_32 == null)) {
                (this.__ɵDomRendererFactory2_32 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["j" /* ɵDomRendererFactory2 */](this._EventManager_30, this._ɵDomSharedStylesHost_31));
            }
            return this.__ɵDomRendererFactory2_32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_RendererFactory2_33", {
        get: function () {
            if ((this.__RendererFactory2_33 == null)) {
                (this.__RendererFactory2_33 = this._ɵDomRendererFactory2_32);
            }
            return this.__RendererFactory2_33;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_\u0275SharedStylesHost_34", {
        get: function () {
            if ((this.__ɵSharedStylesHost_34 == null)) {
                (this.__ɵSharedStylesHost_34 = this._ɵDomSharedStylesHost_31);
            }
            return this.__ɵSharedStylesHost_34;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Testability_35", {
        get: function () {
            if ((this.__Testability_35 == null)) {
                (this.__Testability_35 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["i" /* Testability */](this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* NgZone */])));
            }
            return this.__Testability_35;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Meta_36", {
        get: function () {
            if ((this.__Meta_36 == null)) {
                (this.__Meta_36 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["k" /* Meta */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__Meta_36;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Title_37", {
        get: function () {
            if ((this.__Title_37 == null)) {
                (this.__Title_37 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["l" /* Title */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__Title_37;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_BrowserXhr_38", {
        get: function () {
            if ((this.__BrowserXhr_38 == null)) {
                (this.__BrowserXhr_38 = new __WEBPACK_IMPORTED_MODULE_9__angular_http__["a" /* BrowserXhr */]());
            }
            return this.__BrowserXhr_38;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_ResponseOptions_39", {
        get: function () {
            if ((this.__ResponseOptions_39 == null)) {
                (this.__ResponseOptions_39 = new __WEBPACK_IMPORTED_MODULE_9__angular_http__["b" /* BaseResponseOptions */]());
            }
            return this.__ResponseOptions_39;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_XSRFStrategy_40", {
        get: function () {
            if ((this.__XSRFStrategy_40 == null)) {
                (this.__XSRFStrategy_40 = new __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_tracking_module__["a" /* NoXSRFStrategy */]());
            }
            return this.__XSRFStrategy_40;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_XHRBackend_41", {
        get: function () {
            if ((this.__XHRBackend_41 == null)) {
                (this.__XHRBackend_41 = new __WEBPACK_IMPORTED_MODULE_9__angular_http__["c" /* XHRBackend */](this._BrowserXhr_38, this._ResponseOptions_39, this._XSRFStrategy_40));
            }
            return this.__XHRBackend_41;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_RequestOptions_42", {
        get: function () {
            if ((this.__RequestOptions_42 == null)) {
                (this.__RequestOptions_42 = new __WEBPACK_IMPORTED_MODULE_9__angular_http__["d" /* BaseRequestOptions */]());
            }
            return this.__RequestOptions_42;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Http_43", {
        get: function () {
            if ((this.__Http_43 == null)) {
                (this.__Http_43 = __WEBPACK_IMPORTED_MODULE_9__angular_http__["e" /* ɵc */](this._XHRBackend_41, this._RequestOptions_42));
            }
            return this.__Http_43;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Tracking_44", {
        get: function () {
            if ((this.__Tracking_44 == null)) {
                (this.__Tracking_44 = new __WEBPACK_IMPORTED_MODULE_12__app_shared_tracking_tracking_service__["a" /* Tracking */](this._Http_43, this._Auth_5, this._CookieService_4, this._TRACKING_CONFIG_6));
            }
            return this.__Tracking_44;
        },
        enumerable: true,
        configurable: true
    });
    CompatModuleInjector.prototype.createInternal = function () {
        this._CommonModule_0 = new __WEBPACK_IMPORTED_MODULE_2__angular_common__["b" /* CommonModule */]();
        this._AUTH_CONFIG_1 = {
            baseUrl: 'https://www.freelancer.com/auth',
            authHashCookie: 'GETAFREE_AUTH_HASH_V2',
            userIdCookie: 'GETAFREE_USER_ID'
        };
        this._COOKIE_OPTIONS_2 = {};
        this._CookieOptionsProvider_3 = new __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_src_cookie_options_provider__["a" /* CookieOptionsProvider */](this._COOKIE_OPTIONS_2, this);
        this._CookieService_4 = __WEBPACK_IMPORTED_MODULE_17_ngx_cookie_src_cookie_factory__["a" /* cookieServiceFactory */](this._CookieOptionsProvider_3);
        this._Auth_5 = new __WEBPACK_IMPORTED_MODULE_4__app_shared_auth_auth_service__["a" /* Auth */](this._AUTH_CONFIG_1, this._CookieService_4);
        this._TRACKING_CONFIG_6 = {
            trackingEndpoint: 'https://t.freelancer.com/0px.gif',
            sessionCookie: '_tracking_session',
            navigationPerformanceSamplingRate: 1,
            enableErrorTracking: true,
            sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
            gitRevision: '425b66ab2e6',
            buildDate: 'Tue May 30 2017 22:39:13 GMT-0400 (EDT)'
        };
        this._ErrorTracking_7 = new __WEBPACK_IMPORTED_MODULE_5__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */](this._Auth_5, this._TRACKING_CONFIG_6);
        this._ErrorHandler_8 = new __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_custom_error_handler_service__["a" /* CustomErrorHandler */](this._ErrorTracking_7);
        this._APP_INITIALIZER_9 = [
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* ɵo */],
            __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["m" /* ɵc */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["n" /* NgProbeToken */], null), this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["k" /* NgProbeToken */], null))
        ];
        this._ApplicationInitStatus_10 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["l" /* ApplicationInitStatus */](this._APP_INITIALIZER_9);
        this._ɵf_11 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["m" /* ɵf */](this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* NgZone */]), this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["n" /* ɵConsole */]), this, this._ErrorHandler_8, this.componentFactoryResolver, this._ApplicationInitStatus_10);
        this._ApplicationRef_12 = this._ɵf_11;
        this._ApplicationModule_13 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* ApplicationModule */](this._ApplicationRef_12);
        this._BrowserModule_14 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["o" /* BrowserModule */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["o" /* BrowserModule */], null));
        this._CookieModule_15 = new __WEBPACK_IMPORTED_MODULE_8_ngx_cookie_index__["a" /* CookieModule */]();
        this._HttpModule_16 = new __WEBPACK_IMPORTED_MODULE_9__angular_http__["f" /* HttpModule */]();
        this._AuthModule_17 = new __WEBPACK_IMPORTED_MODULE_10__app_shared_auth_auth_module__["a" /* AuthModule */]();
        this._TrackingModule_18 = new __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_tracking_module__["b" /* TrackingModule */]();
        this._CompatModule_19 = new __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__["a" /* CompatModule */]();
        return this._CompatModule_19;
    };
    CompatModuleInjector.prototype.getInternal = function (token, notFoundResult) {
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_common__["b" /* CommonModule */])) {
            return this._CommonModule_0;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_18__app_shared_auth_auth_config__["a" /* AUTH_CONFIG */])) {
            return this._AUTH_CONFIG_1;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_src_cookie_options_provider__["b" /* COOKIE_OPTIONS */])) {
            return this._COOKIE_OPTIONS_2;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_src_cookie_options_provider__["a" /* CookieOptionsProvider */])) {
            return this._CookieOptionsProvider_3;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_19_ngx_cookie_src_cookie_service__["a" /* CookieService */])) {
            return this._CookieService_4;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__app_shared_auth_auth_service__["a" /* Auth */])) {
            return this._Auth_5;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_20__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */])) {
            return this._TRACKING_CONFIG_6;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_5__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */])) {
            return this._ErrorTracking_7;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["p" /* ErrorHandler */])) {
            return this._ErrorHandler_8;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["q" /* APP_INITIALIZER */])) {
            return this._APP_INITIALIZER_9;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["l" /* ApplicationInitStatus */])) {
            return this._ApplicationInitStatus_10;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["m" /* ɵf */])) {
            return this._ɵf_11;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["r" /* ApplicationRef */])) {
            return this._ApplicationRef_12;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* ApplicationModule */])) {
            return this._ApplicationModule_13;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["o" /* BrowserModule */])) {
            return this._BrowserModule_14;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_8_ngx_cookie_index__["a" /* CookieModule */])) {
            return this._CookieModule_15;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_9__angular_http__["f" /* HttpModule */])) {
            return this._HttpModule_16;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_10__app_shared_auth_auth_module__["a" /* AuthModule */])) {
            return this._AuthModule_17;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_tracking_module__["b" /* TrackingModule */])) {
            return this._TrackingModule_18;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__["a" /* CompatModule */])) {
            return this._CompatModule_19;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["c" /* LOCALE_ID */])) {
            return this._LOCALE_ID_20;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_common__["c" /* NgLocalization */])) {
            return this._NgLocalization_21;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* Compiler */])) {
            return this._Compiler_22;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["s" /* APP_ID */])) {
            return this._APP_ID_23;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["t" /* IterableDiffers */])) {
            return this._IterableDiffers_24;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["u" /* KeyValueDiffers */])) {
            return this._KeyValueDiffers_25;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["p" /* DomSanitizer */])) {
            return this._DomSanitizer_26;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["v" /* Sanitizer */])) {
            return this._Sanitizer_27;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["q" /* HAMMER_GESTURE_CONFIG */])) {
            return this._HAMMER_GESTURE_CONFIG_28;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["r" /* EVENT_MANAGER_PLUGINS */])) {
            return this._EVENT_MANAGER_PLUGINS_29;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["h" /* EventManager */])) {
            return this._EventManager_30;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["i" /* ɵDomSharedStylesHost */])) {
            return this._ɵDomSharedStylesHost_31;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["j" /* ɵDomRendererFactory2 */])) {
            return this._ɵDomRendererFactory2_32;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["w" /* RendererFactory2 */])) {
            return this._RendererFactory2_33;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["s" /* ɵSharedStylesHost */])) {
            return this._ɵSharedStylesHost_34;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["i" /* Testability */])) {
            return this._Testability_35;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["k" /* Meta */])) {
            return this._Meta_36;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["l" /* Title */])) {
            return this._Title_37;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_9__angular_http__["a" /* BrowserXhr */])) {
            return this._BrowserXhr_38;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_9__angular_http__["g" /* ResponseOptions */])) {
            return this._ResponseOptions_39;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_9__angular_http__["h" /* XSRFStrategy */])) {
            return this._XSRFStrategy_40;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_9__angular_http__["c" /* XHRBackend */])) {
            return this._XHRBackend_41;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_9__angular_http__["i" /* RequestOptions */])) {
            return this._RequestOptions_42;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_9__angular_http__["j" /* Http */])) {
            return this._Http_43;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_12__app_shared_tracking_tracking_service__["a" /* Tracking */])) {
            return this._Tracking_44;
        }
        return notFoundResult;
    };
    CompatModuleInjector.prototype.destroyInternal = function () {
        this._ɵf_11.ngOnDestroy();
        (this.__ɵDomSharedStylesHost_31 && this._ɵDomSharedStylesHost_31.ngOnDestroy());
    };
    return CompatModuleInjector;
}(__WEBPACK_IMPORTED_MODULE_0__angular_core__["x" /* ɵNgModuleInjector */]));
var CompatModuleNgFactory = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["y" /* NgModuleFactory */](CompatModuleInjector, __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__["a" /* CompatModule */]);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0Lm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==
//# sourceMappingURL=compat.module.ngfactory.js.map

/***/ }),

/***/ "D/cT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compat_compat_chat_component__ = __webpack_require__("WzIl");
/* unused harmony export RenderType_CompatChatComponent */
/* unused harmony export View_CompatChatComponent_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatChatComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_CompatChatComponent = [];
var RenderType_CompatChatComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_11" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_CompatChatComponent,
    data: {}
});
function View_CompatChatComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [], null, null);
}
function View_CompatChatComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'app-compat-chat', [], null, null, null, View_CompatChatComponent_0, RenderType_CompatChatComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](49152, null, 0, __WEBPACK_IMPORTED_MODULE_1__compat_compat_chat_component__["a" /* CompatChatComponent */], [], null, null)
    ], null, null);
}
var CompatChatComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* ɵccf */]('app-compat-chat', __WEBPACK_IMPORTED_MODULE_1__compat_compat_chat_component__["a" /* CompatChatComponent */], View_CompatChatComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC1jaGF0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQtY2hhdC5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQtY2hhdC5jb21wb25lbnQudHMuQ29tcGF0Q2hhdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxhcHAtY29tcGF0LWNoYXQ+PC9hcHAtY29tcGF0LWNoYXQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO2dCQUFBOzs7OyJ9
//# sourceMappingURL=compat-chat.component.ngfactory.js.map

/***/ }),

/***/ "EVHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_service__ = __webpack_require__("sVtB");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserTimingTrackingComponent; });

var UserTimingTrackingComponent = (function () {
    function UserTimingTrackingComponent(t) {
        this.t = t;
        this.timingMarkOffset = 0; // keep track of the timing marks already reported
    }
    UserTimingTrackingComponent.prototype.ngOnInit = function () {
        // Only enable if the browser supports the User Timing API
        // (http://caniuse.com/#feat=user-timing)
        if (!(window.performance && window.performance.getEntriesByType)) {
            return;
        }
        this.reportTimingMarks();
    };
    UserTimingTrackingComponent.prototype.reportTimingMarks = function () {
        var _this = this;
        window.requestIdleCallback(function () {
            var marks = window.performance.getEntriesByType('mark');
            if (marks.length > _this.timingMarkOffset) {
                for (var i = _this.timingMarkOffset; i < marks.length; i++) {
                    var mark = marks[i];
                    var t = Math.round(mark.startTime);
                    if (t >= 0 && t < 3600000) {
                        var p = {
                            mark_name: mark.name,
                            mark_time: t
                        };
                        _this.t.track('user_timing', p);
                    }
                    _this.timingMarkOffset += marks.length;
                }
            }
            // Use the Page Visibility API to stop the collection if available
            if (document.hidden) {
                var onVisible_1 = function () {
                    document.removeEventListener('visibilitychange', onVisible_1);
                    setTimeout(function () { return _this.reportTimingMarks(); }, 1000);
                };
                document.addEventListener('visibilitychange', onVisible_1);
            }
            else {
                // TODO: User PerformanceObserver when it's more widely supported
                setTimeout(function () { return _this.reportTimingMarks(); }, 1000);
            }
        });
    };
    UserTimingTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__tracking_service__["a" /* Tracking */] }]; };
    return UserTimingTrackingComponent;
}());

//# sourceMappingURL=user-timing-tracking.component.js.map

/***/ }),

/***/ "F5VT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_combineLatest__ = __webpack_require__("XlOA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_combineLatest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_combineLatest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_concat__ = __webpack_require__("1ZrL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_empty__ = __webpack_require__("AGQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_from__ = __webpack_require__("S35O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_interval__ = __webpack_require__("SUuD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_interval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_interval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_merge__ = __webpack_require__("fICK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of__ = __webpack_require__("1APj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_throw__ = __webpack_require__("h0qH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_throw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_throw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_bufferTime__ = __webpack_require__("Di9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_bufferTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_bufferTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_catch__ = __webpack_require__("6Yye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_combineLatest__ = __webpack_require__("qp8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_combineLatest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_combineLatest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_concat__ = __webpack_require__("/rMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_debounceTime__ = __webpack_require__("aV5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_debounceTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_debounceTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_distinctUntilChanged__ = __webpack_require__("q3ik");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_distinctUntilChanged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_distinctUntilChanged__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_do__ = __webpack_require__("EnA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_do___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_do__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_filter__ = __webpack_require__("wUn1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_first__ = __webpack_require__("okk1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_mapTo__ = __webpack_require__("6gFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_mapTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_mapTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_merge__ = __webpack_require__("EGMK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mergeMap__ = __webpack_require__("HcJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_multicast__ = __webpack_require__("j7ye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_multicast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_multicast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_pluck__ = __webpack_require__("xOQQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_pluck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_pluck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_scan__ = __webpack_require__("zJQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_scan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_scan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_startWith__ = __webpack_require__("/lY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_startWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_startWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_switchMap__ = __webpack_require__("uCY4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_take__ = __webpack_require__("hzF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_toPromise__ = __webpack_require__("eErF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_withLatestFrom__ = __webpack_require__("fiy1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_withLatestFrom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_withLatestFrom__);
// See node_module/rxjs/Rxjs.js
// Import just the rxjs statics and operators needed for THIS app.
// Statics








// Operators





















//# sourceMappingURL=rxjs-operators.js.map

/***/ }),

/***/ "I5QD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compat_compat_contact_list_component__ = __webpack_require__("8mlE");
/* unused harmony export RenderType_CompatContactListComponent */
/* unused harmony export View_CompatContactListComponent_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatContactListComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_CompatContactListComponent = [];
var RenderType_CompatContactListComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_11" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_CompatContactListComponent,
    data: {}
});
function View_CompatContactListComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [], null, null);
}
function View_CompatContactListComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'app-compat-contact-list', [], null, null, null, View_CompatContactListComponent_0, RenderType_CompatContactListComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](49152, null, 0, __WEBPACK_IMPORTED_MODULE_1__compat_compat_contact_list_component__["a" /* CompatContactListComponent */], [], null, null)
    ], null, null);
}
var CompatContactListComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* ɵccf */]('app-compat-contact-list', __WEBPACK_IMPORTED_MODULE_1__compat_compat_contact_list_component__["a" /* CompatContactListComponent */], View_CompatContactListComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC1jb250YWN0LWxpc3QuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC1jb250YWN0LWxpc3QuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0LWNvbnRhY3QtbGlzdC5jb21wb25lbnQudHMuQ29tcGF0Q29udGFjdExpc3RDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLWNvbXBhdC1jb250YWN0LWxpc3Q+PC9hcHAtY29tcGF0LWNvbnRhY3QtbGlzdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7Z0JBQUE7Ozs7In0=
//# sourceMappingURL=compat-contact-list.component.ngfactory.js.map

/***/ }),

/***/ "LV28":
/***/ (function(module, exports) {

//# sourceMappingURL=auth.interface.js.map

/***/ }),

/***/ "OTuB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_config__ = __webpack_require__("Tz6n");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthModule; });

var AuthModule = (function () {
    function AuthModule() {
    }
    AuthModule.initialize = function (config) {
        return {
            ngModule: AuthModule,
            providers: [
                { provide: __WEBPACK_IMPORTED_MODULE_0__auth_config__["a" /* AUTH_CONFIG */], useValue: config }
            ]
        };
    };
    return AuthModule;
}());

//# sourceMappingURL=auth.module.js.map

/***/ }),

/***/ "SPEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_synthetic_performance_tracking_component__ = __webpack_require__("yUzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngx_cookie_src_cookie_service__ = __webpack_require__("A+9r");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_SyntheticPerformanceTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_SyntheticPerformanceTrackingComponent_0;
/* unused harmony export SyntheticPerformanceTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_SyntheticPerformanceTrackingComponent = [];
var RenderType_SyntheticPerformanceTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_11" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_SyntheticPerformanceTrackingComponent,
    data: {}
});
function View_SyntheticPerformanceTrackingComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [(l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_SyntheticPerformanceTrackingComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'fl-synthetic-performance-tracking', [], null, null, null, View_SyntheticPerformanceTrackingComponent_0, RenderType_SyntheticPerformanceTrackingComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_synthetic_performance_tracking_component__["a" /* SyntheticPerformanceTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_2_ngx_cookie_src_cookie_service__["a" /* CookieService */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["_17" /* Renderer2 */]
        ], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var SyntheticPerformanceTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* ɵccf */]('fl-synthetic-performance-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_synthetic_performance_tracking_component__["a" /* SyntheticPerformanceTrackingComponent */], View_SyntheticPerformanceTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvc3ludGhldGljLXBlcmZvcm1hbmNlLXRyYWNraW5nLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3N5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3N5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuU3ludGhldGljUGVyZm9ybWFuY2VUcmFja2luZ0NvbXBvbmVudC5odG1sIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmcuY29tcG9uZW50LnRzLlN5bnRoZXRpY1BlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+PC9mbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt5QkNBQTs7OztJQ0FBO2dCQUFBOzs7SUFBQTtLQUFBOzs7SUFBQTs7OyJ9
//# sourceMappingURL=synthetic-performance-tracking.component.ngfactory.js.map

/***/ }),

/***/ "TZHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_cookie__ = __webpack_require__("VffS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_config__ = __webpack_require__("Tz6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_interface__ = __webpack_require__("LV28");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__auth_interface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_ReplaySubject__ = __webpack_require__("MQMf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_ReplaySubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_ReplaySubject__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Auth; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





;
var Auth = (function (_super) {
    __extends(Auth, _super);
    function Auth(authConfig, cookies) {
        var _this = _super.call(this, 1) || this;
        _this.authConfig = authConfig;
        _this.cookies = cookies;
        var uid = parseInt(_this.cookies.get(_this.authConfig.userIdCookie), 10);
        var token = _this.cookies.get(_this.authConfig.authHashCookie);
        _this.next({ uid: uid, token: token });
        return _this;
    }
    Auth.prototype.setState = function (uid, token) {
        this.cookies.put(this.authConfig.userIdCookie, uid.toString());
        this.cookies.put(this.authConfig.authHashCookie, token);
        this.next({ uid: uid, token: token });
    };
    /*login(): Promise<void> {
      // TODO
    }
  
    logout(): Promise<void> {
      // TODO
      // this.next({});
    }*/
    Auth.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_3__auth_interface__["AuthConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["E" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_2__auth_config__["a" /* AUTH_CONFIG */]] }] }, { type: __WEBPACK_IMPORTED_MODULE_1__shared_cookie__["a" /* CookieService */] }]; };
    return Auth;
}(__WEBPACK_IMPORTED_MODULE_4_rxjs_ReplaySubject__["ReplaySubject"]));

//# sourceMappingURL=auth.service.js.map

/***/ }),

/***/ "Tz6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_CONFIG; });

var AUTH_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["_10" /* OpaqueToken */]('AuthConfig');
//# sourceMappingURL=auth.config.js.map

/***/ }),

/***/ "UbRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_tracking_service__ = __webpack_require__("maH+");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomErrorHandler; });

var CustomErrorHandler = (function () {
    function CustomErrorHandler(errorTracking) {
        this.errorTracking = errorTracking;
    }
    CustomErrorHandler.prototype.handleError = function (error) {
        this.errorTracking.captureException(error);
    };
    CustomErrorHandler.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__error_tracking_service__["a" /* ErrorTracking */] }]; };
    return CustomErrorHandler;
}());

//# sourceMappingURL=custom-error-handler.service.js.map

/***/ }),

/***/ "VffS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ngx_cookie__ = __webpack_require__("9db2");
/* unused harmony reexport CookieModule */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_ngx_cookie__["b"]; });
// We use https://github.com/salemdar/ngx-cookie, refer to the API docs there.

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "WzIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatChatComponent; });
var CompatChatComponent = (function () {
    function CompatChatComponent() {
    }
    CompatChatComponent.ctorParameters = function () { return []; };
    return CompatChatComponent;
}());

//# sourceMappingURL=compat-chat.component.js.map

/***/ }),

/***/ "ZrHe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatTrackingComponent; });
var CompatTrackingComponent = (function () {
    function CompatTrackingComponent() {
    }
    return CompatTrackingComponent;
}());

//# sourceMappingURL=compat-tracking.component.js.map

/***/ }),

/***/ "cjBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_tracking_service__ = __webpack_require__("maH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_interface__ = __webpack_require__("yQXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tracking_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemoryLeakTrackingComponent; });




var MemoryLeakTrackingComponent = (function () {
    function MemoryLeakTrackingComponent(errorTracking, config) {
        this.errorTracking = errorTracking;
        this.config = config;
        this.CHECK_INTERVAL = 10000; // 10 seconds
        this.MAX_MEMORY_LIMIT = 1000 * 1048576; // 1000MB
        this.MAX_PERCENT_THRESHOLD = 90;
        this.hadAlarmed = false;
    }
    MemoryLeakTrackingComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!(window.performance && window.performance.memory)) {
            return;
        }
        setTimeout(function () { return _this.checkMemoryUsage(); }, this.CHECK_INTERVAL);
    };
    MemoryLeakTrackingComponent.prototype.checkMemoryUsage = function () {
        var _this = this;
        requestAnimationFrame(function () {
            var hasAlarmed = false;
            var _a = window.performance.memory, jsHeapSizeLimit = _a.jsHeapSizeLimit, totalJSHeapSize = _a.totalJSHeapSize, usedJSHeapSize = _a.usedJSHeapSize;
            // Check if we've exceeded absolute memory limit
            if (usedJSHeapSize > _this.MAX_MEMORY_LIMIT) {
                hasAlarmed = true;
                var overage = usedJSHeapSize - _this.MAX_MEMORY_LIMIT;
                _this.errorTracking.captureMessage('Exceeded memory maximum limit', {
                    extra: { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize, overage: overage }
                });
            }
            // Check if we've exceeded relative memory limit for client
            if (usedJSHeapSize > (_this.MAX_PERCENT_THRESHOLD / 100) * jsHeapSizeLimit) {
                hasAlarmed = true;
                _this.errorTracking.captureMessage('Memory usage exceeded', {
                    extra: {
                        jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize,
                        MAX_PERCENT_THRESHOLD: _this.MAX_PERCENT_THRESHOLD
                    }
                });
            }
            // Only alert once
            if (!hasAlarmed) {
                setTimeout(function () { return _this.checkMemoryUsage(); }, _this.CHECK_INTERVAL);
            }
        });
    };
    MemoryLeakTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__error_tracking_service__["a" /* ErrorTracking */] }, { type: __WEBPACK_IMPORTED_MODULE_3__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["E" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_2__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return MemoryLeakTrackingComponent;
}());

//# sourceMappingURL=memory-leak-tracking.component.js.map

/***/ }),

/***/ "jT3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_user_timing_tracking_component__ = __webpack_require__("EVHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__ = __webpack_require__("sVtB");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_UserTimingTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_UserTimingTrackingComponent_0;
/* unused harmony export UserTimingTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_UserTimingTrackingComponent = [];
var RenderType_UserTimingTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_11" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_UserTimingTrackingComponent,
    data: {}
});
function View_UserTimingTrackingComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [(l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_UserTimingTrackingComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'fl-user-timing-tracking', [], null, null, null, View_UserTimingTrackingComponent_0, RenderType_UserTimingTrackingComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_user_timing_tracking_component__["a" /* UserTimingTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__["a" /* Tracking */]], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var UserTimingTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* ɵccf */]('fl-user-timing-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_user_timing_tracking_component__["a" /* UserTimingTrackingComponent */], View_UserTimingTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdXNlci10aW1pbmctdHJhY2tpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdXNlci10aW1pbmctdHJhY2tpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy91c2VyLXRpbWluZy10cmFja2luZy5jb21wb25lbnQudHMuVXNlclRpbWluZ1RyYWNraW5nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3VzZXItdGltaW5nLXRyYWNraW5nLmNvbXBvbmVudC50cy5Vc2VyVGltaW5nVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC11c2VyLXRpbWluZy10cmFja2luZz48L2ZsLXVzZXItdGltaW5nLXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7eUJDQUE7Ozs7SUNBQTtnQkFBQTs7O0lBQUE7OzsifQ==
//# sourceMappingURL=user-timing-tracking.component.ngfactory.js.map

/***/ }),

/***/ "k/7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_auth__ = __webpack_require__("5/rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_config__ = __webpack_require__("7eNd");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoXSRFStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TrackingModule; });


var NoXSRFStrategy = (function () {
    function NoXSRFStrategy() {
    }
    NoXSRFStrategy.prototype.configureRequest = function (req) {
        // Remove `x-xsrf-token` from request headers since the tracking backend
        // doesn't care, and it avoids uneeded CORS preflight requests
    };
    return NoXSRFStrategy;
}());

var TrackingModule = (function () {
    function TrackingModule() {
    }
    TrackingModule.initialize = function (config, authConfig) {
        return {
            ngModule: TrackingModule,
            providers: [
                { provide: __WEBPACK_IMPORTED_MODULE_1__tracking_config__["a" /* TRACKING_CONFIG */], useValue: config },
                { provide: __WEBPACK_IMPORTED_MODULE_0__shared_auth__["a" /* AUTH_CONFIG */], useValue: authConfig }
            ]
        };
    };
    return TrackingModule;
}());

//# sourceMappingURL=tracking.module.js.map

/***/ }),

/***/ "kZql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return environment; });
var environment = {
    production: true,
    gafBaseUrl: 'https://www.freelancer.com',
    authConfig: {
        baseUrl: 'https://www.freelancer.com/auth',
        authHashCookie: 'GETAFREE_AUTH_HASH_V2',
        userIdCookie: 'GETAFREE_USER_ID',
    },
    datastoreConfig: {
        apiBaseUrl: 'https://www.freelancer.com/api',
        ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
        webSocketUrl: 'https://notifications.freelancer.com'
    },
    trackingConfig: {
        trackingEndpoint: 'https://t.freelancer.com/0px.gif',
        sessionCookie: '_tracking_session',
        navigationPerformanceSamplingRate: 1,
        enableErrorTracking: true,
        sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
        gitRevision: '425b66ab2e6',
        buildDate: 'Tue May 30 2017 22:39:13 GMT-0400 (EDT)'
    },
    billingConfig: {
        baseUrl: 'https://api.flnbln.net',
    },
    facebookAppId: '',
    languageCookie: 'GETAFREE_LANGUAGE'
};
//# sourceMappingURL=environment.js.map

/***/ }),

/***/ "maH+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_auth__ = __webpack_require__("5/rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_interface__ = __webpack_require__("yQXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tracking_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorTracking; });





var ErrorTracking = (function () {
    function ErrorTracking(auth, config) {
        this.auth = auth;
        this.config = config;
        if (this.config.enableErrorTracking) {
            __WEBPACK_IMPORTED_MODULE_0_raven_js__["config"](this.config.sentryDsn, {
                release: this.config.gitRevision,
                tags: {
                    releaseDate: this.config.buildDate
                }
            });
        }
    }
    ErrorTracking.prototype.captureMessage = function (msg, options) {
        var _this = this;
        if (this.config.enableErrorTracking) {
            this.auth.map(function (_a) {
                var uid = _a.uid;
                _this.setUserId(uid);
                __WEBPACK_IMPORTED_MODULE_0_raven_js__["captureMessage"](msg, options);
            }).toPromise();
        }
        else {
            console.error(msg, options);
        }
    };
    ErrorTracking.prototype.captureException = function (error) {
        var _this = this;
        if (this.config.enableErrorTracking) {
            this.auth.map(function (_a) {
                var uid = _a.uid;
                _this.setUserId(uid);
                __WEBPACK_IMPORTED_MODULE_0_raven_js__["captureException"](error);
            }).toPromise();
        }
        else {
            console.error(error);
        }
    };
    ErrorTracking.prototype.setUserId = function (id) {
        if (id) {
            __WEBPACK_IMPORTED_MODULE_0_raven_js__["setUserContext"]({ id: String(id) });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0_raven_js__["setUserContext"]();
        }
    };
    ErrorTracking.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__shared_auth__["b" /* Auth */] }, { type: __WEBPACK_IMPORTED_MODULE_4__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["E" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_3__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return ErrorTracking;
}());

//# sourceMappingURL=error-tracking.service.js.map

/***/ }),

/***/ "sVtB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_auth__ = __webpack_require__("5/rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_cookie__ = __webpack_require__("VffS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracking_interface__ = __webpack_require__("yQXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tracking_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tracking; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var Tracking = (function () {
    function Tracking(http, auth, cookies, config) {
        this.http = http;
        this.auth = auth;
        this.cookies = cookies;
        this.config = config;
        this.MAX_GET_LENGTH = 2000;
        var sessionId = this.cookies.get(this.config.sessionCookie);
        if (!sessionId) {
            // Generate a new one if not.
            sessionId = this.generateSessionId();
            this.cookies.put('_tracking_session', sessionId, {
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            });
        }
        this.sessionId = sessionId;
    }
    Tracking.prototype.track = function (eventName, eventData) {
        var _this = this;
        var timestamp = Date.now().toString();
        return new Promise(function (resolve) {
            window.requestIdleCallback(function () {
                _this.auth
                    .switchMap(function (_a) {
                    var uid = _a.uid;
                    var e = __assign({
                        acct: window.location.hostname.replace(/^www/, ''),
                        t: timestamp,
                        en: eventName,
                        location: window.location.href,
                        user_id: uid ? uid : undefined,
                        session_id: _this.sessionId
                    }, eventData);
                    // compute rough payload size
                    var size = Object.values(e).reduce(function (acc, value) {
                        acc += value ? String(value).length : 0;
                        return acc;
                    }, 0);
                    if (size > _this.MAX_GET_LENGTH) {
                        return _this.http.post(_this.config.trackingEndpoint, e);
                    }
                    else {
                        return _this.http.get(_this.config.trackingEndpoint, {
                            search: _this.serialize(e)
                        });
                    }
                })
                    .mapTo(undefined)
                    .toPromise()
                    .then(resolve);
            });
        });
    };
    Tracking.prototype.push = function (e) {
        this.track(e[0], e[1]);
    };
    Tracking.prototype.generateSessionId = function () {
        var s4 = function () { return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1); };
        return "" + s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
    };
    Tracking.prototype.serialize = function (obj) {
        var params = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["k" /* URLSearchParams */]();
        Object.keys(obj).forEach(function (key) {
            params.set(key, obj[key]);
        });
        return params;
    };
    Tracking.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_http__["j" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_2__shared_auth__["b" /* Auth */] }, { type: __WEBPACK_IMPORTED_MODULE_3__shared_cookie__["a" /* CookieService */] }, { type: __WEBPACK_IMPORTED_MODULE_5__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["E" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_4__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return Tracking;
}());

//# sourceMappingURL=tracking.service.js.map

/***/ }),

/***/ "wkYe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_boomerang_boomerang_js__ = __webpack_require__("KjzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_boomerang_boomerang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_boomerang_boomerang_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_boomerang_plugins_auto_xhr_js__ = __webpack_require__("VPKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_boomerang_plugins_auto_xhr_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_boomerang_plugins_auto_xhr_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_boomerang_plugins_spa_js__ = __webpack_require__("/aXI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_boomerang_plugins_spa_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_boomerang_plugins_spa_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_boomerang_plugins_history_js__ = __webpack_require__("AAEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_boomerang_plugins_history_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_boomerang_plugins_history_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_boomerang_plugins_rt_js__ = __webpack_require__("gcTG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_boomerang_plugins_rt_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_boomerang_plugins_rt_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_boomerang_plugins_navtiming_js__ = __webpack_require__("aAem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_boomerang_plugins_navtiming_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_boomerang_plugins_navtiming_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_boomerang_plugins_restiming_js__ = __webpack_require__("gUQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_boomerang_plugins_restiming_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_boomerang_plugins_restiming_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tracking_service__ = __webpack_require__("sVtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking_interface__ = __webpack_require__("yQXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__tracking_interface__);
/* unused harmony export NavigationPerformanceCategory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationPerformanceTrackingComponent; });











var NavigationPerformanceCategory;
(function (NavigationPerformanceCategory) {
    NavigationPerformanceCategory[NavigationPerformanceCategory["INITIAL_PAGE_LOAD"] = 0] = "INITIAL_PAGE_LOAD";
    NavigationPerformanceCategory[NavigationPerformanceCategory["ROUTE_CHANGE"] = 1] = "ROUTE_CHANGE";
})(NavigationPerformanceCategory || (NavigationPerformanceCategory = {}));
var NavigationPerformanceTrackingComponent = (function () {
    function NavigationPerformanceTrackingComponent(t, config) {
        this.t = t;
        this.config = config;
    }
    NavigationPerformanceTrackingComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (Math.random() > this.config.navigationPerformanceSamplingRate) {
            return;
        }
        // Whenever Boomerang intercepts an XHR request, it will check if that
        // request matches anything in the exclude list, and if it does, Boomerang
        // will not instrument, time, or beacon that request
        BOOMR.xhr_excludes = {
            't.freelancer.com': true,
            'googleads.g.doubleclick.net': true,
            'static.doubleclick.net': true,
            'www.googletagmanager.com': true,
            'www.google.com': true,
            'connect.facebook.net': true
        };
        BOOMR.init({
            log: function (message, level, source) {
                if (level === 'error') {
                    console.error(message, source);
                }
            },
            autorun: false,
            History: {
                auto: true,
                enabled: true
            }
        });
        // boomerang as its own error handling thing
        BOOMR.plugins.Errors = {
            is_supported: function () {
                return true;
            },
            is_complete: function () {
                return true;
            },
            send: function (err) {
                throw err;
            }
        };
        var previousUrl;
        BOOMR.subscribe('before_beacon', function (e) {
            if (e['http.initiator'] !== 'spa_hard' && e['http.initiator'] !== 'spa') {
                return;
            }
            // Previous URL
            if (!previousUrl) {
                previousUrl = e.r;
            }
            var data = {
                category: e['http.initiator'] !== 'spa' ?
                    NavigationPerformanceCategory.INITIAL_PAGE_LOAD :
                    NavigationPerformanceCategory.ROUTE_CHANGE,
                totalTime: e.t_done,
                backendTime: e.t_resp,
                frontendTime: e.t_page,
                previousUrl: previousUrl,
                resourceTimings: e.restiming
            };
            // NavigationTimings
            if (e.nt_nav_st) {
                Object.assign(data, {
                    // PerformanceNavigation
                    redirectCount: e.nt_red_cnt,
                    navigationType: e.nt_nav_type,
                    // PerformanceTiming
                    navigationStart: e.nt_nav_st,
                    redirectStart: e.nt_red_st,
                    redirectEnd: e.nt_red_end,
                    fetchStart: e.nt_fet_st,
                    domainLookupStart: e.nt_dns_st,
                    domainLookupEnd: e.nt_dns_end,
                    connectStart: e.nt_con_st,
                    connectEnd: e.nt_con_end,
                    requestStart: e.nt_req_st,
                    responseStart: e.nt_res_st,
                    responseEnd: e.nt_res_end,
                    domLoading: e.nt_domloading,
                    domInteractive: e.nt_domint,
                    domContentLoadedEventStart: e.nt_domcontloaded_st,
                    domContentLoadedEventEnd: e.nt_domcontloaded_end,
                    domComplete: e.nt_domcomp,
                    loadEventStart: e.nt_load_st,
                    loadEventEnd: e.nt_load_end,
                    unloadEventStart: e.nt_unload_st,
                    unloadEventEnd: e.nt_unload_end,
                });
                if (e.nt_first_paint) {
                    // First paint
                    Object.assign(data, {
                        firstPaint: e.nt_first_paint * 1000,
                    });
                }
            }
            // Fire the event
            _this.t.track('page_performance_timings', data);
            // Clear the Resource Timings Buffer
            if (window.performance && window.performance.clearResourceTimings) {
                window.performance.clearResourceTimings();
            }
            previousUrl = window.location.href;
            // Notify boomerang that we've fired the beacon
            BOOMR.fireEvent('onbeacon', data);
        });
    };
    NavigationPerformanceTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_8__tracking_service__["a" /* Tracking */] }, { type: __WEBPACK_IMPORTED_MODULE_10__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["E" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_9__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return NavigationPerformanceTrackingComponent;
}());

//# sourceMappingURL=navigation-performance-tracking.component.js.map

/***/ }),

/***/ "xfqM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_memory_leak_tracking_component__ = __webpack_require__("cjBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_error_tracking_service__ = __webpack_require__("maH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__ = __webpack_require__("7eNd");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_MemoryLeakTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_MemoryLeakTrackingComponent_0;
/* unused harmony export MemoryLeakTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_MemoryLeakTrackingComponent = [];
var RenderType_MemoryLeakTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_11" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_MemoryLeakTrackingComponent,
    data: {}
});
function View_MemoryLeakTrackingComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [(l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_MemoryLeakTrackingComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_12" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_13" /* ɵeld */](0, null, null, 1, 'fl-memory-leak-tracking', [], null, null, null, View_MemoryLeakTrackingComponent_0, RenderType_MemoryLeakTrackingComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_14" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_memory_leak_tracking_component__["a" /* MemoryLeakTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */],
            __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]
        ], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var MemoryLeakTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_15" /* ɵccf */]('fl-memory-leak-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_memory_leak_tracking_component__["a" /* MemoryLeakTrackingComponent */], View_MemoryLeakTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbWVtb3J5LWxlYWstdHJhY2tpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbWVtb3J5LWxlYWstdHJhY2tpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9tZW1vcnktbGVhay10cmFja2luZy5jb21wb25lbnQudHMuTWVtb3J5TGVha1RyYWNraW5nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL21lbW9yeS1sZWFrLXRyYWNraW5nLmNvbXBvbmVudC50cy5NZW1vcnlMZWFrVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1tZW1vcnktbGVhay10cmFja2luZz48L2ZsLW1lbW9yeS1sZWFrLXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3lCQ0FBOzs7O0lDQUE7Z0JBQUE7OztJQUFBO0tBQUE7OztJQUFBOzs7In0=
//# sourceMappingURL=memory-leak-tracking.component.ngfactory.js.map

/***/ }),

/***/ "yQXN":
/***/ (function(module, exports) {

//# sourceMappingURL=tracking.interface.js.map

/***/ }),

/***/ "yUzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_cookie__ = __webpack_require__("VffS");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyntheticPerformanceTrackingComponent; });


var SyntheticPerformanceTrackingComponent = (function () {
    function SyntheticPerformanceTrackingComponent(cookies, renderer) {
        this.cookies = cookies;
        this.renderer = renderer;
    }
    SyntheticPerformanceTrackingComponent.prototype.ngOnInit = function () {
        /**
         * Adds a 'sc-no-animation' class on the root element ('html') when a
         * 'no_animation' cookie is present. This can then be used to disable CSS
         * animations / transitions as they don't play nice with synthetics monitoring
         * & visual completness score (a.k.a. Speed Index).
         */
        if (this.cookies.get('no_animation')) {
            this.renderer.addClass(document.documentElement, 'sc-no-animation');
        }
    };
    SyntheticPerformanceTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__shared_cookie__["a" /* CookieService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_17" /* Renderer2 */] }]; };
    return SyntheticPerformanceTrackingComponent;
}());

//# sourceMappingURL=synthetic-performance-tracking.component.js.map

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.5972ecb6e1464992b783.bundle.js